import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MetaTagInput } from '../metataginput';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

@Component({
    selector: 'pw-meta',
    templateUrl: './meta.component.html',
    styleUrls: ['./meta.component.scss']
})
export class MetaComponent implements OnInit {

    @Input() metaForm?: FormGroup;

    @Input() keywords: string[] = [];

    readonly separatorKeysCodes = [ENTER, COMMA] as const;

    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    addKeyword(event: MatChipInputEvent): void {
        const input = event.chipInput?.inputElement;
        const value = (event.value || '').trim();

        if (value && !this.keywords.includes(value)) {
            this.keywords.push(value);
        }

        if (input) {
            input.value = '';
        }
    }

    removeKeyword(keyword: string): void {
        const index = this.keywords.indexOf(keyword);

        if (index >= 0) {
            this.keywords.splice(index, 1);
        }
    }



}
